module.exports = __webpack_public_path__ + "img/no_ring@3x.d4b0774e.png";